import './registrationInchargeDashboard.css';
import React, { useState, useEffect } from "react";
//import { styled } from '@mui/material/styles';
import sidebarLogo from '../../../images/sidebar-logo.png';
import timeicon from '../../../images/timeicon.png';
import Home from "../../../preregcamps/homepage/homepage";
import { useNavigate } from "react-router-dom";
import Registration from '../../../preregcamps/registration/registration_home';
import Button from '@mui/material/Button';
import Search from '../../../preregcamps/searchbar/searchbar';
import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Shortlisting from '../../../preregcamps/Shortlisting/shortlisting';
import apiClient from '../../../axios';
import jwt from 'jwt-decode';
// import {getLocalStorageItem('id_token') } from '../../common/URLs';
import { GET_MAPPING_DETAILS, GET_USER_DETAILS, GET_ALL_STAKEHOLDERS, STAKEHOLDER_COUNT, CHECK_STATUS} from '../../../common/URLs';
import OnboardingScrutinizers from './onboardScrutinizers';
import RegistrationInchageHomePage from './registrationInchargeHomePage';
import ScrutinizerMapping from './scrutinizerMapping';
import { Container, Row, Col, Stack } from 'react-bootstrap';
import userIcon from "../../../images/userIcon.png";
import hamburger from "../../../images/hamburger_icon.jpg";
import GenerateCard from './generateCard';
import RegistrationScrutiny from '../scrutinizer/registrationScrutiny';
import RegistrationLeadScrutiny from '../leadScrutinizer/registrationLeadScrutiny';
import { ROLES } from '../../../common/constants';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { getUserDetails } from '../../../common/Utils';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));
function RegistrationInchargeDashboard() {
  
    const ColorButton = styled(Button)(() => ({
        marginTop: 20,
        marginLeft: 30,
        width: 150,
        color: '#FFFFFF',
        backgroundColor: '#005BAA',
        '&:hover': {
            backgroundColor: '#FFFFFF',
            color: '#005BAA',
        },
        '&:active': {
            backgroundColor: '#FFFFFF',
            color: '#005BAA',
        }
    }));
let [showDashboard, setShowDashboard] = useState(false);
let [showRegistration, setShowRegistration] = useState(false);
let [showOnboard, setOnboard] = useState(false);
let [showShortlisting, setShowShortlisting] = useState(false);
let [showMapping, setShowMapping] = useState(false);
let [showCardGeneration, setShowCardGeneration] = useState(false);
let [showScrutinyDashboard, setShowScrutinyDashboard] = useState(false);
let [showLeadScrutinyDashboard, setShowLeadScrutinyDashboard] = useState(false);
let [showMultipleRolesDashboard, setShowMultipleRolesDashboard] = useState(false);
 let [roletrue, setRoletrue] = useState(false);
 const [emailId, setEmailId] = useState(localStorage.getItem('InspectorEmail'));
  const [userId, setUserId] = useState();
  const [roles, setRoles] = useState();
  const [userDetails, setUserDetails] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const localRole = localStorage.getItem('role');
  const [reload, setReload] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    };
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const navigate = useNavigate()
    useEffect(() => {
        if (localRole) {
            getUserDetails(emailId, updateUserDetails);
            setRoles(localRole);
            if (localRole === ROLES.RegInCharge) {
                setShowDashboard(true);
                setShowScrutinyDashboard(false);
                setShowLeadScrutinyDashboard(false);
                setShowRegistration(false);
            }
            else if (localRole === ROLES.RegistrationScruitnizer) {
                setShowScrutinyDashboard(true);
                setShowDashboard(false);
                setShowLeadScrutinyDashboard(false);
                setShowRegistration(false);
            }
            else if (localRole === ROLES.LeadRegScrutinizer) {
                setShowLeadScrutinyDashboard(true);
                setShowScrutinyDashboard(false);
                setShowDashboard(false);
                setShowRegistration(false);
            }
            else if (localRole === ROLES.RegAssistant) {
                setShowRegistration(true);
                setShowLeadScrutinyDashboard(false);
                setShowScrutinyDashboard(false);
                setShowDashboard(false);
            }
            setReload(!reload);
        }
    }, [localRole]);
    const updateUserDetails = (response) => {
        setUserDetails(response);
    }
    return (
        <div>
            <Container fluid>
                <Row>                   
                    <Col xs={12} md={12}>
            {
                            showDashboard &&
                            <RegistrationInchageHomePage key={reload}></RegistrationInchageHomePage>
            }
            {
                showScrutinyDashboard &&
                            <RegistrationScrutiny key={reload}></RegistrationScrutiny>
            }
            {
                showLeadScrutinyDashboard &&
                            <RegistrationLeadScrutiny key={reload}></RegistrationLeadScrutiny>
            }
             {
                showMultipleRolesDashboard &&
                    <div>
                                    <RegistrationScrutiny key={reload}></RegistrationScrutiny>
                    </div>
            
            }
            {
                showRegistration &&
                            <Registration  key={reload}></Registration>
            }
            {
              showShortlisting &&
              <Shortlisting></Shortlisting>
            }
             {
              showMapping &&
              <ScrutinizerMapping userID={userId}></ScrutinizerMapping>
            }
	      {
                showOnboard &&
                <OnboardingScrutinizers userID={userId} ></OnboardingScrutinizers>
                        }
          {
            showCardGeneration &&
                            <GenerateCard userID={userId}></GenerateCard>
          }
                    </Col>
          </Row></Container></div>
    )
};

export default RegistrationInchargeDashboard;
